import FooterNav from './FooterNav';

export default FooterNav;